





























































































import Vue from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import CCategorySelect from '~/components/shared/configurable/category/select/CCategorySelect.vue'
import CGoogleAutocompleteInput from '~/components/shared/configurable/form/autocomplete/CGoogleAutocompleteInput.vue'
import { debounce } from '~/utils/function'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import {
  SET_ACTIVE_GEOLOCATION,
  SET_PARAM,
  TOGGLE_MOBILE_FACETS_VISIBLE
} from '~/store/modules/shared/dealers/map/mutation-types'
import { DEALERS_MAP_NS } from '~/store/modules/shared/dealers/map/state'
import { capitalizeSentences } from '~/utils/string'

export default Vue.extend({
  components: {
    CCustomSelect,
    CCategorySelect,
    CGoogleAutocompleteInput
  },
  computed: {
    ...mapGetters(DEALERS_MAP_NS, {
      facetsCount: 'getFacetsCount'
    }),
    ...mapState(DEALERS_MAP_NS, {
      categoriesCounts: state => state.categoriesCounts,
      paramCategory: state => state.params.ca,
      paramQ: state => state.params.q,
      paramPostcode: state => state.params.postcode,
      paramDistance: state => state.params.distance,
      mobileFacetsVisible: (state): boolean => state.mobile.facetsVisible,
      totalDealers: state => state.totalDealers
    }),
    distancesOptions: () => [
      { text: '1km ', value: 1 },
      {
        text: '2km',
        value: 2
      },
      { text: '4km', value: 4 },
      { text: '8km', value: 8 },
      { text: '20km', value: 20 },
      { text: '40km', value: 40 },
      {
        text: '100km',
        value: 100
      },
      { text: '200km', value: 200 }
    ],
    showButtonText() {
      return capitalizeSentences(
        this.$tc('view 1 seller | view {count} sellers', this.totalDealers)
      )
    },
    category: {
      get() {
        if (Array.isArray(this.paramCategory)) {
          return this.paramCategory
        }
        return [this.paramCategory]
      },
      set(category) {
        this.setParam({ name: 'ca', value: category })
        this.search()
      }
    },
    q: {
      get() {
        return this.paramQ
      },
      set: debounce(function(q) {
        this.setParam({ name: 'q', value: q })
        this.setParam({ name: 'pg', value: 1 })
        this.search()
      }, 600)
    },
    postcode: {
      get() {
        return this.paramPostcode
      },
      set: debounce(function(postcode) {
        this.setParam({ name: 'postcode', value: postcode })
        this.search()
      }, 500)
    },
    distance: {
      get() {
        if (typeof this.paramDistance === 'string') {
          return Number(this.paramDistance)
        }
        return this.paramDistance
      },
      set(distance) {
        this.setParam({ name: 'distance', value: distance })
        this.search()
      }
    }
  },
  methods: {
    handleAutocompleteChange({ geolocation, postcode }) {
      this.postcode = postcode
      this.setActiveGeolocation(geolocation)
    },
    ...mapActions(DEALERS_MAP_NS, {
      search: 'search',
      clearAll: 'clearAll'
    }),
    ...mapMutations(DEALERS_MAP_NS, {
      setParam: SET_PARAM,
      setActiveGeolocation: SET_ACTIVE_GEOLOCATION,
      toggleMobileFacetsVisible: TOGGLE_MOBILE_FACETS_VISIBLE
    })
  }
})
